/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface TargetProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Target: React.FC<TargetProps> = ({ color = '#222A34', ...props }) => {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.3334 6.87798V4.37798L15.8334 1.87798L16.6667 3.54464L18.3334 4.37798L15.8334 6.87798H13.3334ZM13.3334 6.87798L10.0001 10.2113M18.3334 10.2113C18.3334 14.8137 14.6025 18.5446 10.0001 18.5446C5.39771 18.5446 1.66675 14.8137 1.66675 10.2113C1.66675 5.60894 5.39771 1.87798 10.0001 1.87798M14.1667 10.2113C14.1667 12.5125 12.3013 14.378 10.0001 14.378C7.6989 14.378 5.83341 12.5125 5.83341 10.2113C5.83341 7.91012 7.6989 6.04464 10.0001 6.04464"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
